import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../utils/hooks/useMutationWithError";
import { SetExpoTokensInput } from "./__generated__/useSetExpoTokensMutation.graphql";

export const useSetExpoTokens = () => {
  const [setUserExpoTokens, isSettingUserExpoTokens] = useMutationWithError(
    useSetUserExpoTokensMutationString
  );

  const onCompleted = (successCallback: any, res: any) => {};

  const onCompletedErrorCustom = (errors: any) => {
    // TODO - handle error?
    return [];
  };

  const handleSetUserExpoTokens = (
    input: SetExpoTokensInput,
    successCallback?: () => void
  ) => {
    setUserExpoTokens({
      variables: { input },
      onCompleted: (res: any) => onCompleted(successCallback, res),
      onCompletedErrorCustom: (errors: any) => onCompletedErrorCustom(errors),
    });
  };

  return [handleSetUserExpoTokens, isSettingUserExpoTokens] as const;
};

const useSetUserExpoTokensMutationString = graphql`
  mutation useSetExpoTokensMutation($input: SetExpoTokensInput!) {
    responsePayload: setExpoTokens(input: $input) {
      errors {
        field
        code
        message
      }
      success
    }
  }
`;
